import React, { useState, useEffect } from 'react';
import { Box, Paper, TextField, Button, Typography, Stack, InputAdornment } from '@mui/material';
import PersonIcon from '@mui/icons-material/PersonOutline';
import LockIcon from '@mui/icons-material/LockOutlined';

export default function LoginPage({ message, onLogin }) {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [submitting, setSubmitting] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');

    useEffect(() => {
        if (message === 'hide') {
            setSubmitting(true);
            setErrorMsg('');
        } else {
            setSubmitting(false);
            setErrorMsg(message || '');
        }
    }, [message]);

    function handleSubmit(event) {
        event.preventDefault();
        setSubmitting(true);
        setErrorMsg('');
        onLogin({ username, password });
    }

    return (
        <Box
            sx={{
                minHeight: '100vh',
                display: 'grid',
                placeItems: 'center',
                p: 2
            }}
        >
            <Paper
                component="form"
                onSubmit={handleSubmit}
                sx={{
                    p: 4,
                    width: '100%',
                    maxWidth: 420,
                    backdropFilter: 'blur(8px)'
                }}
            >
                <Stack spacing={3}>
                    <Box sx={{ textAlign: 'center' }}>
                        <Box
                            component="img"
                            src="/tvm-logo.png"
                            alt="TVM GmbH"
                            sx={{ height: 64, width: 'auto', mb: 1 }}
                        />
                        <Typography variant="body2" color="text.secondary">Anmelden</Typography>
                    </Box>

                    <TextField
                        label="Benutzername"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        autoFocus
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <PersonIcon fontSize="small" />
                                </InputAdornment>
                            )
                        }}
                    />

                    <TextField
                        label="Passwort"
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <LockIcon fontSize="small" />
                                </InputAdornment>
                            )
                        }}
                    />

                    {errorMsg && errorMsg !== 'hide' && (
                        <Typography color="error" variant="body2" sx={{ textAlign: 'center' }}>
                            {errorMsg}
                        </Typography>
                    )}

                    <Button
                        type="submit"
                        variant="contained"
                        size="large"
                        disabled={submitting || !username || !password}
                    >
                        Anmelden
                    </Button>
                </Stack>
            </Paper>
        </Box>
    );
}
